// Import des données JSON directement
import studentData from '../screens/academy/data/studentData.json';
import coursesData from '../screens/academy/data/coursesData.json';
import qcmResultsData from '../screens/academy/data/qcmResultsData.json';
import labelingTestsData from '../screens/academy/data/labelingTestsData.json';

const LocalDataService = {
  
  // Récupérer les données de l'étudiant
  getStudent() {
    return studentData.student;
  },

  // Récupérer la classe de l'étudiant
  getStudentClass() {
    return studentData.studentClass;
  },

  // Récupérer les matières
  getMatieres() {
    return studentData.matieres;
  },

  // Récupérer tous les cours
  getAllCourses() {
    return coursesData.courses;
  },

  // Récupérer les cours d'un utilisateur
  getCoursesByUser(userId) {
    return coursesData.courses;
  },

  // Récupérer un cours par ID
  getCourseById(courseId) {
    return coursesData.courses.find(c => c.id === parseInt(courseId));
  },

  // Récupérer les résultats QCM
  getQcmResults(userId) {
    return qcmResultsData.qcmResults;
  },

  // Ajouter un résultat QCM (simulation)
  addQcmResult(result) {
    qcmResultsData.qcmResults.push(result);
    return { success: true, result };
  },

  // Récupérer les tests de labellisation
  getLabelingTests(userId) {
    return labelingTestsData.availableTests;
  },

  // Mettre à jour un test (après soumission)
  updateLabelingTest(testId, result) {
    const testIndex = labelingTestsData.availableTests.findIndex(t => t.id === testId);
    if (testIndex !== -1) {
      labelingTestsData.availableTests[testIndex].has_submitted = true;
      labelingTestsData.availableTests[testIndex].submitted_results = [result];
    }
    return { success: true };
  },

  // Obtenir le badge de notification
  getNotificationBadge() {
    const activeTests = labelingTestsData.availableTests.filter(t => {
      const activeSession = t.sessions?.find(s => s.status === 'active');
      return activeSession && !t.has_submitted;
    });
    return activeTests.length;
  },

  // Récupérer l'utilisateur courant
  getUser() {
    return {
      data: studentData.student.id,
      dataSpecial: studentData.student
    };
  }
};

export default LocalDataService;